import React from "react";
import { createUser, getUsers } from "../../services/actions/user";
import { useForm } from "../../hooks/useForm";
import styles from './admin.module.scss'
import { FormEvent, useEffect } from "react";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useTranslation } from 'react-i18next';

export function AdminPage() {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { values, handleChange,  setValues} = useForm({
        userName: '',
		email: '',
		password: '',
        role: ''
	});
    useEffect(() => {
        dispatch(getUsers());
    }, [dispatch])
    const users = useAppSelector(state => state.user.users);
	const { userName, email, password, role } = values;
    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        dispatch(createUser({userName, email, password, roles: [role], cities: null}));
        setValues({
            userName: '',
            email: '',
            password: '',
            role: ''
        });
        dispatch(getUsers());
    }
    return (
            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.gradient}></div>
                    <div className={styles.name}>{t('admin.usersHeader')}</div>
                </div>
                <div>
                    {
                        users && users.length > 0 ? users.map((user, key) =>
                            (<div key={key} className={styles.userItem}>
                                <p>{key + 1}</p>
                                <p>{user.userName}</p>
                                <p>{user.roles}</p>
                            </div>)) : null
                    }
                </div>
                <form onSubmit={handleSubmit}>
                    <input value={userName} name='userName' onChange={handleChange} placeholder={t('admin.userNamePlaceholder')}/>
                    <input value={email} name='email' onChange={handleChange} placeholder={t('admin.emailPlaceholder')}/>
                    <input value={password} name='password' onChange={handleChange} placeholder={t('admin.passwordPlaceholder')}/>
                    <input value={role} name='role' onChange={handleChange} placeholder={t('admin.rolePlaceholder')}/>
                    <button>{t('admin.createUserButton')}</button>
                </form>
            </div>
    )
}
